import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { RouteType } from "../models/enum";
import { RoleService } from "../shared/services/role.service";
import { SharedService } from "../shared/services/shared.service";

@Component({
	selector: "app-sidebar",
	templateUrl: "./sidebar.component.html",
	styleUrls: ["./sidebar.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SidebarComponent implements OnInit, OnDestroy {
	activePage!: string;
	expanded: boolean = true;
	private subscriptions = new Subscription();

	constructor(
		private sharedService: SharedService,
		private roleService: RoleService,
		private router: Router,
		private cdr: ChangeDetectorRef,
	) {}

	goTo(path: RouteType) {
		this.router.navigate([path]);
	}

	get isOnline() {
		return navigator.onLine;
	}

	ngOnInit(): void {
		this.subscriptions.add(
			this.sharedService.getActivePage().subscribe((activePage: string) => {
				this.activePage = activePage || this.roleService.getDefaultRoute();
				this.cdr.detectChanges();
			}),
		);
		this.subscriptions.add(
			this.roleService.getAuthenticatedUser().subscribe(() => {
				if (!this.activePage) {
					this.activePage = this.roleService.getDefaultRoute();
				}
				this.cdr.detectChanges();
			}),
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}

	get routeType() {
		return RouteType;
	}

	get rs() {
		return this.roleService;
	}

	onExpandedClick(): void {
		// this.sharedService.setSideBarExpanded(!this.expanded);
		this.expanded = !this.expanded;
	}

	signout(): void {
		this.sharedService.logout();
	}
}
